import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import TemplatesPublicGridComponent from 'webapp/components/templates/public/grid';

import type Template from 'webapp/models-custom/template';
import type ReportRecord from 'webapp/models/report';

export default class ReportsPublicTemplatesRouteTemplate extends Component {
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('popup') declare popupService: Service.Popup;

	get model(): Template[] {
		return this.mmTemplatesService.reportPublicTemplateModels;
	}

	@action
	previewTemplate(model: Template): void {
		this.navigationService.transitionToRoute('reports.public-templates.template', model);
	}

	@action
	useTemplate(model: Template): void {
		const afterUse = (reportRecord: ReportRecord) => {
			const isTemplatesPath = this.navigationService.activatedRoute.includes(
				'reports.public-templates',
			);

			let afterTransition = () => {
				/* do nothing */
			};

			if (isTemplatesPath && !this.popupService.anyPopupsOpen) {
				afterTransition = () => {
					const reportModel = this.mmReportsService.createModel(reportRecord);
					this.mmReportsService.openPreviewPopup(reportModel);
				};
			}

			this.navigationService.transitionToRoute('reports.index').then(afterTransition);
		};

		this.mmTemplatesService.trackEvent(model, TrackingEvent.USE_A_TEMPLATE);

		this.mmReportsService.createReportFromTemplate(model, 'report_public_template', afterUse);
	}

	<template>
		<div id="public-templates" class="view-grid">
			<TemplatesPublicGridComponent
				@model={{this.model}}
				@previewTemplate={{this.previewTemplate}}
				@useTemplate={{this.useTemplate}}
			/>
		</div>
	</template>
}
